import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import getParameterByName from "../../Functions/functions";
import { useDispatch, useSelector } from "react-redux";
import { getUserRoles } from "./actions";
const roleName = getParameterByName("roleName");
const status = getParameterByName("status");

export const viewOnlyStatusforAllPages = (invoice, roleName, RoleId,roles)=>{

 
  

  let specificRoute = null; 
    if(invoice.Status.includes("SendToIP")){
       specificRoute = `/#/processInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
        roleName
      }&roleId=${RoleId}&vendorCode=${
        invoice?.["Vendor Code"]
      }&status=${invoice.Status}&edit=false` 
      return specificRoute;
    }
    if(invoice.Status.includes("SendToIR")){
      const IRRole = roles?.filter((item) => {
        return item.roleName?.toLowerCase() === "ir";
      });
        specificRoute = `/#/viewOnlyPageDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${IRRole[0].roleName}&roleId=${IRRole[0].roleId}&status=${invoice?.Status}&edit=false`
        return specificRoute;
    }
    if(invoice.Status.includes("SubmittedByVendor")){
      const ViewRole = roles?.filter((item) => {
        return item.roleName?.toLowerCase() === "view only";
      });
        specificRoute = `/#/viewOnlyPageDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${ViewRole[0].roleName}&roleId=${ViewRole[0].roleId}&status=${invoice?.Status}&edit=false`
        return specificRoute;
    }
    if(invoice.Status.includes("SendToTaxTeam")){
        specificRoute = `/#/taxteamdetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
         roleName
       }&roleId=${RoleId}&vendorCode=${
         invoice?.["Vendor Code"]
       }&status=${invoice.Status}&edit=false` 
       return specificRoute; 
     }
     if(invoice.Status.includes("SendToReviewer")){
        specificRoute = `/#/reviwerInvoiceDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
         roleName
       }&roleId=${RoleId}&vendorCode=${
         invoice?.["Vendor Code"]
       }&status=${invoice.Status}&edit=false` 
       return specificRoute;
     }
     if(invoice.Status.includes("SendToDeptCoordinator")){
        specificRoute = `/#/departmentDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
         roleName
       }&roleId=${RoleId}&vendorCode=${
         invoice?.["Vendor Code"]
       }&status=${invoice.Status}&edit=false` 
       return specificRoute;
     }
     if(invoice.Status.includes("SendToLoamApprover")){
        specificRoute = `/#/LoamDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
         roleName
       }&roleId=${RoleId}&vendorCode=${
         invoice?.["Vendor Code"]
       }&status=${invoice.Status}&edit=false` 
       return specificRoute;
     }
     if(invoice.Status.includes("SendToInitiator")){
      const I2PRole = roles?.filter((item) => {
        return item.roleName?.toLowerCase() === "i2p initiator";
      });
        specificRoute = `/#/viewOnlyPageDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${I2PRole[0].roleName}&roleId=${I2PRole[0].roleId}&vendorCode=${
         invoice?.["Vendor Code"]
       }&status=${invoice.Status}&edit=false` 
       return specificRoute;
     }
     if(invoice.Status.includes("SendToImport")){
      const ImportRole = roles?.filter((item) => {
        return item.roleName?.toLowerCase() === "import";
      });
        specificRoute = `/#/viewOnlyPageDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${ImportRole[0].roleName}&roleId=${ImportRole[0].roleId}&vendorCode=${
         invoice?.["Vendor Code"]
       }&status=${invoice.Status}&edit=false` 
       return specificRoute;
     } 
     if(invoice.Status.includes("SendToHR")){
      const HRRole = roles?.filter((item) => {
        return item.roleName?.toLowerCase() === "hr";
      });
      specificRoute = `/#/viewOnlyPageDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${HRRole[0]?.roleName}&roleId=${HRRole[0]?.roleId}&status=${invoice.Status}&edit=false` 
      return specificRoute;
   }
   if(invoice.Status.includes("SendToEfdvInitiator")){
  
    const EFDVRole = roles?.filter((item) => {
      return item.roleName?.toLowerCase() === "EFDV Inititator";
    });
    console.log(EFDVRole,"EFDVRole")
    specificRoute = `/#/invoice?invoiceId=${invoice?.Invoice_Id}&roleName=EFDV Initiator&roleId=c57255c1-49a1-46e1-b492-b20f5ccd71dd&status=${invoice.Status}&edit=false` 
    return specificRoute;
 }
   if(invoice.Status.includes("SendToLineManager")){
    specificRoute = `/#/LineManagerDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
     roleName
   }&roleId=${RoleId}&status=${invoice.Status}&edit=false` 
   return specificRoute; 
 }
 if(invoice.Status.includes("SendToSharedServices")){
  specificRoute = `/#/SharedServicesDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
   roleName
 }&roleId=${RoleId}&status=${invoice.Status}&edit=false` 
 return specificRoute; 
}
if(invoice.Status.includes("SendToDirectorHR")){
  specificRoute = `/#/DirectorHRDetail?invoiceId=${invoice?.Invoice_Id}&roleName=${
   roleName
 }&roleId=${RoleId}&status=${invoice.Status}&edit=false` 
 return specificRoute;
}
else{
  const ViewRole = roles?.filter((item) => {
    return item.roleName?.toLowerCase() === "view only";
  });
  specificRoute = `/#/APS_InvoiceDetailPage?invoiceId=${invoice?.Invoice_Id}&roleName=View%20Only&roleId=${ViewRole[0].roleId}&vendorCode=${invoice?.["Vendor Code"]}&status=${invoice.Status}&edit=false`
  return specificRoute;
}

};